import React, { useEffect } from 'react';
import Home from './Home';
import Portfolio from 'sections/Portfolio';
import TopBar from 'sections/TopBar';
import Footer from 'sections/Footer';
import * as styledComponents from './styles';
import DetectMobile from 'helpers/DetectMobile.js';
import Benefits from './Benefits';

const Landing = () => {
  useEffect(()=>{
    (async ()=> {await gtag('config', "G-S3JNHMJ2KX", {'page_title' : 'ProjectScoping', 'page_path': window.location.pathname});
    })();
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }, []);

  let offsetTop = -65;
  if(DetectMobile()){
    offsetTop = 0;
  }

  return (
    <styledComponents.LandingContainer>
      <TopBar />
      <Home />
      <Benefits />
      <Portfolio />
      <Footer />
    </styledComponents.LandingContainer>
  );
}

export default Landing;
